import { render, staticRenderFns } from "./DatasetName.vue?vue&type=template&id=d2be893e&scoped=true"
import script from "./DatasetName.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetName.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DatasetName.vue?vue&type=style&index=0&id=d2be893e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2be893e",
  null
  
)

export default component.exports